<template>
  <div style="padding: 10px">
    <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
      <p slot="header" style="text-align:center">
        <Icon type="md-create" />
        <span>显示项设置</span>
      </p>
      <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
      </tr>-->
      <Form label-position="left" :label-width="100" style="margin-left:20px">
        <FormItem label="展示数据">
          <Tag
            :checked="showColumnTitleArray.indexOf(item.title) > -1"
            v-for="item in columnsbackup"
            :name="item.title"
            @on-change="changeColumn"
            size="medium"
            checkable
            color="primary"
          >{{item.title}}</Tag>
        </FormItem>
      </Form>
      <div slot="footer">
        <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
      </div>
    </Modal>
    <Modal v-model="isShowStateModal" :mask-closable="false" width="380">
      <p slot="header" style="color:#19be6b;text-align:center">
        <Icon type="md-create" />
        <span>详细状态</span>
      </p>
      <table>
        <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr>
      </table>
      <div slot="footer"></div>
    </Modal>
    <div style="background: #fff; border-radius: 8px; padding: 20px;">
      <div class="query-c">
        <Row style="white-space:nowrap;">
          <Col
            span="15"
            style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
          >
            <div style="margin-left:3%;">
              <br />
              <div>
                <Select
                  clearable
                  filterable
                  placeholder="请选择行政区"
                  v-model="addressfield1"
                  style="width:19%"
                >
                  <Option
                    v-for="item in addressObject.addressfield1"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="请选择小区"
                  v-model="addressfield2"
                  style="width:19%;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield1"
                    v-for="item in addressObject.addressfield2"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="请选择楼栋"
                  v-model="addressfield3"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield2"
                    v-for="item in addressObject.addressfield3"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="请选择单元"
                  v-model="addressfield4"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield3"
                    v-for="item in addressObject.addressfield4"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <Select
                  clearable
                  filterable
                  placeholder="请选择门牌"
                  v-model="addressfield5"
                  style="width:19%;;margin-left:5px"
                >
                  <Option
                    v-if="item.pid == addressfield4"
                    v-for="item in addressObject.addressfield5"
                    :value="item.id"
                    :key="item.id"
                  >{{ item.name }}</Option>
                </Select>
                <!-- <Select filterable placeholder="请选择设备地址" v-model="meterAddress" style="width:150px;;margin-left:5px">
                <Option v-for="item in meterArray" :value="item" :key="item">{{ item }}</Option>
                </Select>-->
              </div>
              <div style="margin-top:5px">
                <Input v-model="consumerNumber" style="width:19%" placeholder="输入用户编号" />
                <Input
                  v-model="consumerName"
                  style="width:19%;margin-left:5px"
                  placeholder="输入用户姓名"
                />
                <Input
                  v-model="consumerPhone"
                  style="width:19%;margin-left:5px"
                  placeholder="输入用户联系电话"
                />
                <Select
                  v-if="getUserMeterType() == undefined || getUserMeterType() == '流量计'"
                  clearable
                  v-model="meterType"
                  style="width:19%;margin-left:5px"
                  placeholder="选择设备类型"
                >
                  <Option
                    v-for="item in showOrder"
                    :value="item"
                    :key="item"
                  >{{ userMeterTypeEnum[item] }}</Option>
                </Select>
              </div>
              <div style="margin-top:5px">
                <DatePicker v-model="startDate" type="date" placeholder="起始日期" style="width: 19%"></DatePicker>
                <DatePicker
                  v-model="endDate"
                  type="date"
                  placeholder="结束日期"
                  style="width: 19%;margin-left:5px"
                ></DatePicker>

                <Button
                  style="margin-left:49%;width: 9%;"
                  type="primary"
                  icon="ios-search"
                  @click="showPage"
                >查询</Button>
              </div>
              <br />
            </div>
          </Col>
          <Col
            span="3"
            style="border:3px solid #57A3F3;padding:2px;margin:2px;border-radius: 25px;"
          >
            <div style="margin-left:15%">
              <br />
              <br />
              <Button
                type="primary"
                @click="exportTable"
                style="width:80%;margin-top:15px;margin-bottom:15px"
              >导出当前页</Button>
              <br />
              <br />
              <br />
            </div>
          </Col>
          <Col span="5" style="margin-left:35px">
            <br />
            <Button
              type="primary"
              @click="isShowSetModal = true"
              style="margin-left: 20px;float:right"
            >显示项设置</Button>
          </Col>
        </Row>
      </div>
      <br />
      <Table
        size="small"
        :height="tableHeight"
        border
        stripe
        :columns="columns"
        :data="data"
        ref="table"
        highlight-row
      >
        <!-- <template slot-scope="{ row, index }" slot="action">
          <Button
            type="primary"
            size="small"
            style="margin-right: 5px"
            @click="showState(row)"
          >查看设备状态</Button>
        </template>-->
      </Table>
      <br />
      <!-- <Page :total="100" show-sizer show-elevator /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "historydata",
  data() {
    return {
      pageName: "historydata",
      showColumnTitleArray: [],
      columnsbackup: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          width: 160
        },
        {
          title: "联系电话",
          key: "联系电话",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          width: 300,
          resizable: true
        },
        {
          title: "表具类型",
          key: "meterType",
          width: 160
        },
        {
          title: "表具地址",
          width: 160,
          key: "messageAddress"
        },
        {
          title: "口径",
          key: "meterCaliber",
          width: 160
        },
        {
          title: "上报时间",
          key: "上报时间",
          width: 180
        },
        {
          title: "瞬时流量",
          key: "瞬时流量",
          width: 160
        },
        {
          title: "正向流量值",
          key: "正向流量值",
          width: 160
        },
        {
          title: "反向流量值",
          key: "反向流量值",
          width: 160
        },
        {
          title: "水温",
          key: "水温",
          width: 160
        },
        {
          title: "压力",
          key: "当前压力",
          width: 160
        },
        {
          title: "运行时间",
          key: "运行时间",
          width: 160
        },
        {
          title: "故障时间",
          key: "故障时间",
          width: 160
        },
        {
          title: "表上时间",
          key: "表上时间",
          width: 180
        },
        {
          title: "电池电压",
          key: "电池电压",
          width: 160
        },
        {
          title: "信号强度",
          key: "信号强度",
          width: 160
        },
        {
          title: "设备状态",
          key: "设备状态",
          width: 160
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ],
      tableHeight: "200",
      addressfield1: "",
      addressfield2: "",
      addressfield3: "",
      addressfield4: "",
      addressfield5: "",
      consumerName: "",
      consumerNumber: "",
      consumerPhone: "",
      userMeterTypeEnum: {
        "0": "水表",
        "5": "流量计",
        "1": "热量表",
        "2": "动态平衡阀",
        "3": "消防栓",
        "4": "压力开关、流量开关"
      },
      showOrder: ["0", "5"],
      meterType: "",
      // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
      //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
      //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
      //   "00000018005405", "00000018005456", "00000018005462"
      // ],
      meterArray: [],
      meterArray1: [
        "00000018003155",
        "00000018004361",
        "00000018004457",
        "00000018004523",
        "00000018004798",
        "00000018005064",
        "00000018005332",
        "00000018005401",
        "00000018005456",
        "00000018005462",
        "11110000000000"
      ],
      meterArray2: ["00000018005405", "00000018004345", "00000018004799"],
      addressObject: {},
      stateContrast: global.stateContrast,
      meterAddress: "",
      stateArray: {},
      startDate: "",
      endDate: "",
      isShowStateModal: false,
      isShowSetModal: false,
      columns: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          width: 160
        },
        {
          title: "联系电话",
          key: "联系电话",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          width: 300,
          resizable: true
        },
        {
          title: "表具类型",
          key: "meterType",
          width: 160
        },
        {
          title: "表具地址",
          width: 160,
          key: "messageAddress"
        },
        {
          title: "口径",
          key: "meterCaliber",
          width: 160
        },
        {
          title: "上报时间",
          key: "上报时间",
          width: 180
        },
        {
          title: "瞬时流量",
          key: "瞬时流量",
          width: 160
        },
        {
          title: "正向流量值",
          key: "正向流量值",
          width: 160
        },
        {
          title: "反向流量值",
          key: "反向流量值",
          width: 160
        },
        {
          title: "水温",
          key: "水温",
          width: 160
        },
        {
          title: "压力",
          key: "当前压力",
          width: 160
        },
        {
          title: "运行时间",
          key: "运行时间",
          width: 160
        },
        {
          title: "故障时间",
          key: "故障时间",
          width: 160
        },
        {
          title: "表上时间",
          key: "表上时间",
          width: 180
        },
        {
          title: "电池电压",
          key: "电池电压",
          width: 160
        },
        {
          title: "信号强度",
          key: "信号强度",
          width: 160
        },
        {
          title: "设备状态",
          key: "设备状态",
          width: 160
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ],
      data: []
    };
  },
  methods: {
    getUserMeterType() {
      return global.searchMeterType();
    },
    exportTable() {
      this.$refs.table.exportCsv({
        filename: "历史数据",
        original: false
      });
    },
    generateColumnTitleArray() {
      let titleArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        titleArray.push(this.columnsbackup[i].title);
      }

      this.showColumnTitleArray = titleArray;

      if (
        localStorage.getItem(
          this.pageName + localStorage.getItem("userAccount")
        ) != undefined
      ) {
        this.showColumnTitleArray = JSON.parse(
          localStorage.getItem(
            this.pageName + localStorage.getItem("userAccount")
          )
        );
        var showArray = [];
        for (let i = 0; i < this.columnsbackup.length; i++) {
          let currentObject = this.columnsbackup[i];
          if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
            showArray.push(currentObject);
          }
        }

        this.columns = showArray;
      }
    },
    getAddressEnum() {
      var that = this;
      that.$axios
        .post("/api/dictionary/selectAddressEnum", {})
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.addressObject = data.body;
          that.addressObject.addressfield5.sort(function(a, b) {
            return (
              a.name.replace("号", "").replace("-", "") -
              b.name.replace("号", "").replace("-", "")
            );
          });
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    },
    parseDate(str) {
      var year = str.substr(0, 4);
      var month = str.substr(4, 2);
      var day = str.substr(6, 2);
      var hour = str.substr(8, 2);
      var minute = str.substr(10, 2);
      var second = str.substr(12, 2);
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hour +
        ":" +
        minute +
        ":" +
        second
      );
    },
    onClickSearch() {
      this.showPage();
    },
    showState(row) {
      this.isShowStateModal = true;
      this.stateArray = JSON.parse(row.messageContent).decode.state;
    },
    showStateStr(row) {
      let stateArray = JSON.parse(row.messageContent).decode.state;
      let that = this;
      let stateStr = "";
      let meterType = row.meterType;
      Object.keys(stateArray).forEach(function(key) {
        if (
          (meterType == "流量计" ||
            meterType == "水表") &&
          (key == "进水温度传感器" || key == "出水温度传感器")
        ) {
        } else if (stateArray[key] == that.stateContrast[key]) {
          stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
        }
      });

      return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
    },
    changeColumn(checked, name) {
      if (checked) {
        this.showColumnTitleArray.push(name);
      } else {
        this.showColumnTitleArray.splice(
          this.showColumnTitleArray.indexOf(name),
          1
        );
      }

      var showArray = [];

      for (let i = 0; i < this.columnsbackup.length; i++) {
        let currentObject = this.columnsbackup[i];
        if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
          showArray.push(currentObject);
        }
      }

      localStorage.setItem(
        this.pageName + localStorage.getItem("userAccount"),
        JSON.stringify(this.showColumnTitleArray)
      );

      this.columns = showArray;
    },
    showPage() {
      var that = this;
      if (
        that.startDate == undefined ||
        that.endDate == undefined ||
        that.startDate == "" ||
        that.endDate == ""
      ) {
        that.$Modal.info({
          title: "提示",
          content: "请输入起止时间"
        });
        return;
      }
      that.data = [];
      that.$axios
        .post("/api/warn/selectWarn", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5,
          consumerPhone: that.consumerPhone,
          consumerNumber: that.consumerNumber,
          consumerName: that.consumerName,
          searchType: 3,
          meterArray: that.meterArray,
          startDate: that.startDate,
          endDate: new Date(that.endDate.getTime() + 3600000*24),
          meterAddress: that.meterAddress,
          meterType:
            that.meterType != "" && that.meterType != undefined
              ? that.userMeterTypeEnum[that.meterType]
              : ""
        })
        .then(function(res) {
          console.log(res);

          let currentArray = [];
          // if (localStorage.getItem('userName') == 'fjyd') {
          //   let bodyArray = res.body;
          //   for (let i = 0; i < bodyArray.length; i++) {
          //     let currentObject = bodyArray[i];
          //     let currentAddress = currentObject.messageAddress;
          //     if (that.meterArray1.indexOf(currentAddress) > -1) {
          //       currentArray.push(currentObject);
          //     }
          //   }
          // }else if(localStorage.getItem('userName') == 'hawiceshi') {
          //   let bodyArray = res.body;
          //   for (let i = 0; i < bodyArray.length; i++) {
          //     let currentObject = bodyArray[i];
          //     let currentAddress = currentObject.messageAddress;
          //     if (that.meterArray2.indexOf(currentAddress) > -1) {
          //       currentArray.push(currentObject);
          //     }
          //   }
          // }  else {
          //   currentArray = res.body;
          // }
          currentArray = res.body;
          console.log(currentArray);

          for (let i = 0; i < currentArray.length; i++) {
            let temp = currentArray[i];

            temp["用户编号"] = "\t" + temp.consumerNumber;
            temp["联系电话"] = "\t" + temp.consumerPhone;
            temp["安装地址"] =
              (temp.addressfield1Name == null ? "" : temp.addressfield1Name) +
              (temp.addressfield2Name == null
                ? ""
                : " - " + temp.addressfield2Name) +
              (temp.addressfield3Name == null
                ? ""
                : " - " + temp.addressfield3Name) +
              (temp.addressfield4Name == null
                ? ""
                : " - " + temp.addressfield4Name) +
              (temp.addressfield5Name == null
                ? " "
                : " - " + temp.addressfield5Name);
            temp["上报时间"] =
              "\t" +
              global.dateFtt(
                "yyyy-MM-dd hh:mm:ss",
                new Date(temp.messageTimestamp)
              );
            // temp["瞬时流量"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.瞬时流量.value +JSON.parse(temp.messageContent).decode.paramArray.瞬时流量.unit;
            // temp["正向流量值"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.正向流量值.value +	JSON.parse(temp.messageContent).decode.paramArray.正向流量值.unit;
            // temp["反向流量值"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.反向流量值.value +	JSON.parse(temp.messageContent).decode.paramArray.反向流量值.unit;
            // temp["水温"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.出水温度.value +	JSON.parse(temp.messageContent).decode.paramArray.出水温度.unit;
            // temp["运行时间"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.运行时间.value +	JSON.parse(temp.messageContent).decode.paramArray.运行时间.unit;
            // temp["故障时间"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.故障时间.value +	JSON.parse(temp.messageContent).decode.paramArray.故障时间.unit;
            temp["表上时间"] =
              "\t" +
              that.parseDate(
                JSON.parse(temp.messageContent).decode.paramArray.表上时间.value
              );
            // temp["电池电压"] = temp.messageContent == undefined?"":JSON.parse(temp.messageContent).decode.paramArray.电池电压.value +	JSON.parse(temp.messageContent).decode.paramArray.电池电压.unit;
            temp["信号强度"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.信号强度
                    .value +
                  JSON.parse(temp.messageContent).decode.paramArray.信号强度
                    .unit;
            temp["设备状态"] = that.showStateStr(temp);
            temp["冷量值"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.冷量值
                    .value +
                  JSON.parse(temp.messageContent).decode.paramArray.冷量值.unit;
            temp["热量值"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.热量值
                    .value +
                  JSON.parse(temp.messageContent).decode.paramArray.热量值.unit;
            temp["功率"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.功率.value +
                  JSON.parse(temp.messageContent).decode.paramArray.功率.unit;
            temp["出水温度"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.出水温度
                    .value +
                  (JSON.parse(temp.messageContent).decode.paramArray.出水温度
                    .unit?JSON.parse(temp.messageContent).decode.paramArray.出水温度
                    .unit:(JSON.parse(temp.messageContent).decode.paramArray.出水温度
                    .unit  + " ℃"));
            temp["进水温度"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.进水温度
                    .value +
                  (JSON.parse(temp.messageContent).decode.paramArray.进水温度
                    .unit?JSON.parse(temp.messageContent).decode.paramArray.进水温度
                    .unit:(JSON.parse(temp.messageContent).decode.paramArray.进水温度
                    .unit  + " ℃"));
            temp["当前压力"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.当前压力
                    .value+
                  JSON.parse(temp.messageContent).decode.paramArray.当前压力
                    .unit;
            // temp["正向流量值"] = temp.messageContent == undefined?"":Math.round(parseFloat(JSON.parse(temp.messageContent).decode.paramArray.正向流量值.value) / 1000 * 100) / 100 + " m³";
            // temp["反向流量值"] = temp.messageContent == undefined?"":Math.round(parseFloat(JSON.parse(temp.messageContent).decode.paramArray.反向流量值.value) / 1000 * 100) / 100 + " m³";

            temp["瞬时流量"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.瞬时流量
                    .value + " m³/h";
            temp["正向流量值"] =
              temp.messageContent == undefined
                ? ""
                : Math.round(
                    (parseFloat(
                      JSON.parse(temp.messageContent).decode.paramArray
                        .正向流量值.value
                    ) /
                      1000) *
                      100
                  ) / 100 + " m³";
            temp["反向流量值"] =
              temp.messageContent == undefined
                ? ""
                : Math.round(
                    (parseFloat(
                      JSON.parse(temp.messageContent).decode.paramArray
                        .反向流量值.value
                    ) /
                      1000) *
                      100
                  ) / 100 + " m³";
            temp["水温"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.出水温度
                    .value + " ℃";
            temp["运行时间"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.运行时间
                    .value  + " h";
            temp["故障时间"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.故障时间
                    .value + " h";
            temp["电池电压"] =
              temp.messageContent == undefined
                ? ""
                : JSON.parse(temp.messageContent).decode.paramArray.电池电压
                    .value + " V";

            // if(i == 0){
            //   for(let l = 0; l < that.columns.length; l ++){
            //     let tempObj = that.columns[l];

            //     let key = tempObj.key;
            //     tempObj.title = temp[key]
            //   }
            // }
            currentArray[i] = temp;
          }

          that.data = currentArray;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    async getMeterArray() {
      var that = this;
      that.$axios
        .post("/api/meter/selectMeterList", {
          addressfield1: that.addressfield1,
          addressfield2: that.addressfield2,
          addressfield3: that.addressfield3,
          addressfield4: that.addressfield4,
          addressfield5: that.addressfield5
        })
        .then(data => {
          if (data.errorCode != 0) {
            that.$Notice.error({
              title: "异常",
              desc: data.errorInfo
            });
            return;
          }

          that.meterArray = data.body;
          //   that.showPage();
          console.log(data.body);
        })
        .catch(error => {
          that.$Notice.error({
            title: "异常",
            desc: error
          });
          console.log(error);
        })
        .finally(() => {});
    }
  },
  mounted() {
    // this.showPage();
    let that = this;
    window.addEventListener("resize", function() {
      that.tableHeight = (window.innerHeight - 186) * 0.65;
    });
    that.tableHeight = (window.innerHeight - 186) * 0.65;

    this.generateColumnTitleArray();
    that.getMeterArray();
    that.getAddressEnum();

     var cs = [];
    if (localStorage.getItem("userMeterType") == 0) {
      cs = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          width: 160
        },
        {
          title: "联系电话",
          key: "联系电话",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          width: 300,
          resizable: true
        },
        {
          title: "表具类型",
          key: "meterType",
          width: 160
        },
        {
          title: "表具地址",
          width: 160,
          key: "messageAddress"
        },
        {
          title: "口径",
          key: "meterCaliber",
          width: 160
        },
        {
          title: "上报时间",
          key: "上报时间",
          width: 180
        },
        {
          title: "瞬时流量",
          key: "瞬时流量",
          width: 160
        },
        {
          title: "正向流量值",
          key: "正向流量值",
          width: 160
        },
        {
          title: "反向流量值",
          key: "反向流量值",
          width: 160
        },
        {
          title: "水温",
          key: "水温",
          width: 160
        },
        {
          title: "压力",
          key: "当前压力",
          width: 160
        },
        {
          title: "运行时间",
          key: "运行时间",
          width: 160
        },
        {
          title: "故障时间",
          key: "故障时间",
          width: 160
        },
        {
          title: "表上时间",
          key: "表上时间",
          width: 180
        },
        {
          title: "电池电压",
          key: "电池电压",
          width: 160
        },
        {
          title: "信号强度",
          key: "信号强度",
          width: 160
        },
        {
          title: "设备状态",
          key: "设备状态",
          width: 160
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ];
    }

    if (localStorage.getItem("userMeterType") == 1) {
      cs = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          width: 160
        },
        {
          title: "联系电话",
          key: "联系电话",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          width: 300,
          resizable: true
        },
        {
          title: "表具类型",
          key: "meterType",
          width: 160
        },
        {
          title: "表具地址",
          width: 160,
          key: "messageAddress"
        },
        {
          title: "口径",
          key: "meterCaliber",
          width: 160
        },
        {
          title: "上报时间",
          key: "上报时间",
          width: 180
        },
        {
          title: "瞬时流量",
          key: "瞬时流量",
          width: 160
        },
        {
          title: "热量值",
          key: "热量值",
          width: 160
        },
        {
          title: "冷量值",
          key: "冷量值",
          width: 160
        },
        {
          title: "流量值",
          key: "正向流量值",
          width: 160
        },
        {
          title: "功率",
          key: "功率",
          width: 160
        },
        {
          title: "进水温度",
          key: "进水温度",
          width: 160
        },
        {
          title: "出水温度",
          key: "出水温度",
          width: 160
        },
        {
          title: "运行时间",
          key: "运行时间",
          width: 160
        },
        {
          title: "故障时间",
          key: "故障时间",
          width: 160
        },
        {
          title: "表上时间",
          key: "表上时间",
          width: 180
        },
        {
          title: "电池电压",
          key: "电池电压",
          width: 160
        },
        {
          title: "信号强度",
          key: "信号强度",
          width: 160
        },
        {
          title: "设备状态",
          key: "设备状态",
          width: 160
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ];
    }

    if (localStorage.getItem("userMeterType") == 5) {
      cs = [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "用户编号",
          key: "用户编号",
          resizable: true,
          width: 160
        },
        {
          title: "用户姓名",
          key: "consumerName",
          resizable: true,
          width: 160
        },
        {
          title: "联系电话",
          key: "联系电话",
          resizable: true,
          width: 160
        },
        {
          title: "安装地址",
          key: "安装地址",
          width: 300,
          resizable: true
        },
        {
          title: "表具类型",
          key: "meterType",
          width: 160
        },
        {
          title: "表具地址",
          width: 160,
          key: "messageAddress"
        },
        {
          title: "口径",
          key: "meterCaliber",
          width: 160
        },
        {
          title: "上报时间",
          key: "上报时间",
          width: 180
        },
        {
          title: "瞬时流量",
          key: "瞬时流量",
          width: 160
        },
        {
          title: "流量值",
          key: "正向流量值",
          width: 160
        },
        {
          title: "水温",
          key: "水温",
          width: 160
        },
        {
          title: "压力",
          key: "当前压力",
          width: 160
        },
        {
          title: "故障时间",
          key: "故障时间",
          width: 160
        },
        {
          title: "表上时间",
          key: "表上时间",
          width: 180
        },
        {
          title: "电池电压",
          key: "电池电压",
          width: 160
        },
        {
          title: "信号强度",
          key: "信号强度",
          width: 160
        },
        {
          title: "设备状态",
          key: "设备状态",
          width: 160
        }
        // ,
        // {
        //   title: "设备状态",
        //   slot: "action",
        //   width: 150,
        //   align: "center"
        // }
      ];
    }

    that.columns = cs;
    that.columnsbackup = cs;
  }
};
</script>

<style scoped>
</style>
